<template>
  <v-tooltip top>
    <v-btn icon slot="activator" @click="manage()">
      <v-icon color="deep-purple lighten-2">open_in_new</v-icon>
    </v-btn>
    <span>Manage</span>
  </v-tooltip>
</template>

<script>
export default {
  methods: {
    manage() {
      this.$emit("manage");
    }
  }
};
</script>

<style>
</style>
